"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _date = require("../util/date");

var _CalendarContext = _interopRequireWildcard(require("../CalendarContext"));

var _classnames = _interopRequireDefault(require("../util/classnames"));

var _TBody = _interopRequireDefault(require("./TBody"));

var _getChangedValue = _interopRequireDefault(require("./getChangedValue"));

var C_COL = 3;
var C_ROW = 4;
var defaultMonths = _CalendarContext.DefaultContext.locale.months;

var MonthPanel = function MonthPanel(_ref) {
  var now = _ref.now,
      value = _ref.value,
      onChange = _ref.onChange,
      current = _ref.current,
      disabledMonth = _ref.disabledMonth;
  var valueYear = (0, _react.useMemo)(function () {
    return value === null || value === void 0 ? void 0 : value.getFullYear();
  }, [value]);
  var valueMonth = (0, _react.useMemo)(function () {
    return value === null || value === void 0 ? void 0 : value.getMonth();
  }, [value]);
  var currentYear = (0, _react.useMemo)(function () {
    return current === null || current === void 0 ? void 0 : current.getFullYear();
  }, [current]);
  var nowYear = (0, _react.useMemo)(function () {
    return now === null || now === void 0 ? void 0 : now.getFullYear();
  }, [now]);
  var nowMonth = (0, _react.useMemo)(function () {
    return now === null || now === void 0 ? void 0 : now.getMonth();
  }, [now]);

  var _useContext = (0, _react.useContext)(_CalendarContext.default),
      locale = _useContext.locale,
      prefixCls = _useContext.prefixCls;

  var months = (locale === null || locale === void 0 ? void 0 : locale.months) || defaultMonths; // use ref to reduce reRender

  var currentRef = (0, _react.useRef)(current);
  var valueRef = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    currentRef.current = current;
    valueRef.current = value;
  }, [current, value]);
  var cells = (0, _react.useMemo)(function () {
    var count = C_COL * C_ROW;
    var cells = [];
    var activeCls = prefixCls + '-active';
    var disabledCls = prefixCls + '-disabled';
    var nowCls = prefixCls + '-now';

    for (var i = 0; i < count; i++) {
      var active = currentYear === valueYear && valueMonth === i;
      var isNow = currentYear === nowYear && nowMonth === i;
      var disabled = disabledMonth === null || disabledMonth === void 0 ? void 0 : disabledMonth((0, _date.set)(current, i, 'month'), value);
      var cellInfo = {
        children: months[i],
        disabled: disabled,
        value: {
          year: currentYear,
          month: i
        },
        className: (0, _classnames.default)(active && activeCls, isNow && nowCls, disabled && disabledCls)
      };
      cells.push(cellInfo);
    }

    return cells;
  }, [prefixCls, currentYear, valueYear, valueMonth, nowYear, nowMonth, disabledMonth, current, value, months]);
  var onMonthClick = (0, _react.useCallback)(function (index) {
    var cellInfo = cells[index];
    if (cellInfo.disabled) return;
    var changedValue = (0, _getChangedValue.default)(cellInfo.value, currentRef.current, valueRef.current);
    onChange(changedValue);
  }, [cells, onChange]);
  var cls = (0, _react.useMemo)(function () {
    return {
      table: prefixCls + '-table'
    };
  }, [prefixCls]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls.table
  }, /*#__PURE__*/_react.default.createElement(_TBody.default, {
    cells: cells,
    onCellClick: onMonthClick,
    col: C_COL,
    row: C_ROW,
    mode: 'month'
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(MonthPanel);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/view/MonthPanel.js
// module id = 1666
// module chunks = 6 7 17 18